// extracted by mini-css-extract-plugin
module.exports = {"root":"RemoveIcon_root__3nx5h","light":"RemoveIcon_light__3mLng","dark":"RemoveIcon_dark__-ByvZ"};